import ReactGA from 'react-ga';

const { REACT_APP_GOOGLE_ANALYTICS_DEV, REACT_APP_GOOGLE_ANALYTICS_PROD, NODE_ENV } = process.env;

export const GA_INIT_CODE =
  NODE_ENV === 'production' ? REACT_APP_GOOGLE_ANALYTICS_PROD : REACT_APP_GOOGLE_ANALYTICS_DEV;

export default history => {
  ReactGA.initialize(GA_INIT_CODE);
  ReactGA.pageview(window.location.pathname + window.location.search);
  history.listen(location => {
    ReactGA.pageview(location.pathname + location.search);
  });
};

export const TIMING_CATEGORIES = {
  forms: 'Work with forms',
};

export const TIMING_VARS = {
  addPatient: 'Add new patient form',
  addReport: 'Add new report form',
  verifyReport: 'Verifying report by doctor',
};
